import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-earn-well-bux-fold',
    templateUrl: './earn-well-bux-fold.component.html',
    styleUrls: ['./earn-well-bux-fold.component.scss'],
    standalone: false
})
export class EarnWellBuxFoldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
